<script setup>
import useStashTable from "./hooks/useStashTable";
import Adjust from "./adjust.vue";
import { onMounted, reactive, ref } from "vue";
import { queryOrganization } from "@/api/organization";
import useUserList from "../hooks/useUserList";

const orgTree = ref([]);

const defaultProps = reactive({
  label: "organizationName",
});

const { userList } = useUserList();

const {
  searchRef,
  searchData,
  tableLoading,
  columns,
  tableData,
  pages,
  adjustRef,
  handleSelectionChange,
  getList,
  handleReset,
  handleAdjust,
  handleExport,
  handleClickDelete,
} = useStashTable();

onMounted(() => {
  getList();
  queryOrganization().then((res) => {
    if (JSON.stringify(res.data) != "{}") {
      orgTree.value = res.data || [];
    }
  });
});
</script>

<template>
  <zh-table-page v-bind="{ title: '仓库管理' }">
    <template #header-btn>
      <el-button type="primary" icon="Plus" @click="handleAdjust(null, 'add')">新增</el-button>
    </template>
    <template #search>
      <el-form :model="searchData" ref="searchRef" label-width="90px">
        <el-row :gutter="10">
          <el-col :span="5">
            <el-form-item label="仓库编号：" prop="number">
              <el-input v-model="searchData.number" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="仓库名称：" prop="name">
              <el-input v-model="searchData.name" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="备注：" prop="remarks">
              <el-input v-model="searchData.remarks" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="所属组织：" prop="orgId">
              <el-tree-select v-model="searchData.orgId" :data="orgTree" placeholder="请选择组织" :props="defaultProps"
                :show-checkbox="true" :check-strictly="true" node-key="organizationCode" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="负责人：" prop="headId">
              <el-select v-model="searchData.headId" placeholder="请输入" style="width: 100%">
                <el-option v-for="item in userList" :key="item.id" :label="item.nikeName" :value="item.userCode" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="仓库地址：" prop="address">
              <el-input v-model="searchData.address" placeholder="请输入" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template #table>
      <el-row>
        <el-button type="primary" icon="Search" @click="getList()">查询</el-button>
        <el-button icon="Refresh" @click="handleReset()">重置</el-button>
        <el-button icon="Download" @click="handleExport()">导出</el-button>
      </el-row>
      <el-table :header-cell-style="{ 'text-align': 'center' }" :cell-style="{
    'text-align': 'center',
  }" style="width: 100%; margin-top: 10px" max-height="650" v-loading="tableLoading" :data="tableData"
        @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" width="55" /> -->
        <template v-for="item in columns" :key="item.prop">
          <el-table-column :label="item.label" :prop="item.prop" :min-width="120" :width="item.width || ''"
            show-overflow-tooltip>
            <template #default="{ row }">
              <span>{{ row[item.prop] || "-" }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" width="150">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleAdjust(row, 'edit')">编辑</el-button><el-button type="primary"
              link @click="handleAdjust(row, 'detail')">详情</el-button>
            <el-button type="danger" link @click="handleClickDelete(row.id, false)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :total="pages.total" v-if="pages.total > 0" layout="->, prev, pager, next"
        v-model:current-page="pages.page" @update:current-page="getList" />
    </template>
  </zh-table-page>
  <Adjust ref="adjustRef" @after-save="getList" />
</template>

<style scoped></style>
